var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcDownloadLinedMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 35,
    viewBox: "0 0 32 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_949_1786)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4949 23.9319C16.3538 24.0764 16.1603 24.1579 15.9583 24.1579C15.7563 24.1579 15.5629 24.0764 15.4217 23.9319L10.4634 18.8546C10.174 18.5583 10.1797 18.0834 10.476 17.794C10.7723 17.5046 11.2472 17.5103 11.5366 17.8066L15.2083 21.5665V6C15.2083 5.58579 15.5441 5.25 15.9583 5.25C16.3725 5.25 16.7083 5.58579 16.7083 6V21.5665L20.38 17.8066C20.6694 17.5103 21.1443 17.5046 21.4406 17.794C21.737 18.0834 21.7426 18.5583 21.4532 18.8546L16.4949 23.9319ZM6 27.25C5.58579 27.25 5.25 27.5858 5.25 28C5.25 28.4142 5.58579 28.75 6 28.75H26C26.4142 28.75 26.75 28.4142 26.75 28C26.75 27.5858 26.4142 27.25 26 27.25H6Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_949_1786",
    x: -4,
    y: -2,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_949_1786"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_949_1786",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDownloadLinedMain);
export default __webpack_public_path__ + "static/media/ic_download_lined_main.e6dccfd22a013c8c44575d2b81cdf074.svg";
export { ForwardRef as ReactComponent };